import * as Yup from 'yup';

const required = 'Campo obrigatório';

export const validationSchema = Yup.object().shape({
  amountCharged: Yup.number()
    .moreThan(0, 'Inserir um valor')
    .required(required),
});
